import type { ReactElement } from "react";
import { Outlet, type RouteObject } from "react-router";

import { NotFoundPage } from "../areas/account/message-pages.js";
import { accountRoutes } from "../areas/account/routes.js";
import { adminCenterRoutes } from "../areas/admin-center/routes.js";
import { estimateRoutes } from "../areas/estimates/routes.js";
import { invoiceRoutes } from "../areas/invoices/routes.js";
import { tenantUserRoutes } from "../areas/tenant-users/routes.js";
import { tenantRoutes } from "../areas/tenants/routes.js";
import { Notice } from "../components/notice.js";

import { BuildVersionWatch } from "./build-version-watch.js";
import { ScrollOnMove } from "./scroll-on-move.js";

/**
 * すべての画面の外側。<b>移った後の通知をここで出す</b>（どの画面でも中身の上）。移ったら先頭へ戻す。
 * 配信の後に開いたままなら、次に別の画面へ移るときにページごと読み込む（<c>build-version-watch.tsx</c>）。
 */
function MemberLayout(): ReactElement {
    return (
        <>
            <BuildVersionWatch />
            <ScrollOnMove />
            <Notice />
            <Outlet />
        </>
    );
}

/**
 * 会員の画面の一覧。<b>URL は今のアプリと同じ</b>（メールや外部に載った URL を切らない）。
 *
 * 画面はまとまりごとに <c>areas/(まとまり)/routes.tsx</c> へ書き、<c>paths/*.json</c> にも足す
 * （テストが突き合わせる）。静的サイトの書き出しはあちらを読み、まだ無い行き先を数える。
 */
export const memberRoutes: RouteObject[] = [
    {
        element: <MemberLayout />,
        children: [
            ...accountRoutes,
            ...tenantRoutes,
            ...tenantUserRoutes,
            ...invoiceRoutes,
            ...adminCenterRoutes,
            ...estimateRoutes,
            { path: "*", element: <NotFoundPage /> },
        ],
    },
];
